export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11489.7e809645.jpg";